// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2bCw4","sendOtp":"AuthorizeToLogin_sendOtp__3XGD-"};